export default function Tooltip() {
  return (
    <div id="tooltip"></div>
  )
}